import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "what-is-rental-pdf"
    }}>{`What is Rental PDF?`}</h2>
    <p>{`Answer: Rental PDF is an extension for RnB & WooCommerce plugin.It helps you to generate the invoice in PDF format for your rental order.`}</p>
    <h2 {...{
      "id": "what-functionalities-does-rental-pdf-provide"
    }}>{`What Functionalities does Rental PDF Provide?`}</h2>
    <p>{`Answer: Rental PDF Helps to Generate rental invoice in both front-end and back-end. In front-end customer can download order invoice from their my account page. Also can download cart as PDF from cart and checkout pages.`}</p>
    <p>{`As admin it provides the opportunity to download the invoice as PDF from both order listing and order details page.`}</p>
    <h2 {...{
      "id": "what-is-the-requirement-for-rental-pdf-to-function-properly"
    }}>{`What is the requirement for Rental PDF to function properly?`}</h2>
    <p>{`Answer:You must have RnB & WooCommerce plugin installed. Rental PDF work as an RnB extension in order to work you will be RnB WooCommerce plugin.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      